import type { LibraryItemView } from '@/lib/api/generated/model';
import { hasUpdate, isInWorkspace } from './presence';

export interface LibraryTotals {
  /** Every item the library holds, readable or not. */
  items: number;
  /** Items this workspace holds, in any state. */
  installed: number;
  /** Items this workspace holds that the library has moved on from. */
  updates: number;
}

/**
 * The three figures the masthead states (spec 105 FR-008).
 *
 * Over the whole catalog, deliberately: the tab counts already describe what is
 * filtered, and a fourth number that moved as the reader typed would compete
 * with them rather than answer anything (FR-009, research R5).
 */
export function libraryTotals(
  items: readonly LibraryItemView[],
): LibraryTotals {
  let installed = 0;
  let updates = 0;
  for (const item of items) {
    if (isInWorkspace(item.state)) installed += 1;
    if (hasUpdate(item.state)) updates += 1;
  }
  return { items: items.length, installed, updates };
}
